import CryptoJS from "crypto-js";
import { PUBLIC_KEY } from "./key/designerPublic";
import JSEncrypt from "jsencrypt";

async function generateAESKey() {
  const randomBytes = CryptoJS.lib.WordArray.random(32);
  return randomBytes.toString(CryptoJS.enc.Base64);
}

async function encryptAESKeyWithRSA(aesKey) {
  if (!aesKey) {
    throw new Error("AES key is required");
  }

  try {
    const encrypt = new JSEncrypt();
    encrypt.setPublicKey(PUBLIC_KEY);
    const encryptedKey = encrypt.encrypt(aesKey);

    if (!encryptedKey) {
      throw new Error("RSA encryption failed");
    }

    return encryptedKey;
  } catch (error) {
    console.error("Error in encryptAESKeyWithRSA:", error);
    throw error;
  }
}

async function encryptData(data) {
  if (!data) {
    throw new Error("Data to encrypt is required");
  }

  try {
    const AESKey = await generateAESKey();
    const encryptedAESKey = await encryptAESKeyWithRSA(AESKey);
    const jsonString = JSON.stringify(data);

    const key = CryptoJS.enc.Base64.parse(AESKey);
    const iv = CryptoJS.lib.WordArray.random(16);

    const encryptedData = CryptoJS.AES.encrypt(
      CryptoJS.enc.Utf8.parse(jsonString),
      key,
      {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }
    ).toString();

    return {
      data: encryptedData,
      AESKey: encryptedAESKey,
      iv: iv.toString(CryptoJS.enc.Base64),
    };
  } catch (error) {
    console.error("Error in encryptData:", error);
    throw error;
  }
}

export default encryptData;
